import {flatMap} from 'lodash';

export default function toSentence(components, options) {
  const { separator,
    lastSeparator = separator,
    tupleSeparator = lastSeparator } = options;
  const { length } = components;

  return flatMap(components, (component, index) => {
    const isFirst = index === 0;
    const isLast = index === length - 1;

    if (isFirst) {
      return component;
    }

    if (length === 2 && isLast) {
      return [tupleSeparator, component];
    }

    if (isLast) {
      return [lastSeparator, component];
    }

    return [separator, component];
  });
}
